import { useProjectId, useProjectUrl } from 'domain/shared/project';
import useStatusesUrl from '../statuses/shared/projectStatusUrl';
import { useAuthorization } from 'framework/authorization';
import { READ_PROJECT_STATUS_LIST } from '../statuses/ProjectStatusesService';
import { READ_PROJECT_REPORTS_LIST } from '../weeklyreports/ProjectWeeklyReportService';
import { useProjectWeeklyReportsUrl } from 'domain/shared/project';
import { PROJECT_CONTEXT } from '../ProjectContext';
import { useProjectDashboardUrl } from '../dashboard/dashboardRouting';
import { READ_PROJECT_DASHBOARD } from '../dashboard/ProjectDashboardService';
import { useWBSProjectDashboardUrl } from '../ProjectsWBSDashboard/useProjectsWBSDashboardService';
import { SidebarStickyMenu, SidebarMenuItem, SummaryMenuItem } from 'framework/ui/menu';

const ViewProjectPageMenu = () => {
  const id = useProjectId();
  const { getSingleEntityUrl } = useProjectUrl();
  const { getListUrl: getStatusesListUrl } = useStatusesUrl();
  const { getListUrl: getReportsListUrl } = useProjectWeeklyReportsUrl();
  const { getListUrl: getDashboardListUrl } = useProjectDashboardUrl();
  const { getListUrl: getWBSDashboardUrl } = useWBSProjectDashboardUrl();
  const { isGranted: globalIsGranted } = useAuthorization();
  const isGranted = (permission: string | string[]) => globalIsGranted(permission, PROJECT_CONTEXT);

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl(id)} />
      <SidebarMenuItem
        linkUrl={getStatusesListUrl()}
        name="Status"
        icon="calendar-check-o"
        isVisible={isGranted(READ_PROJECT_STATUS_LIST)}
      />
      <SidebarMenuItem
        linkUrl={getReportsListUrl()}
        name="Weekly Report"
        icon="area-chart"
        isVisible={isGranted(READ_PROJECT_REPORTS_LIST)}
      />
      <SidebarMenuItem
        linkUrl={getDashboardListUrl()}
        name="Dashboard"
        icon="th-large"
        isVisible={isGranted(READ_PROJECT_DASHBOARD)}
      />
      {/* TODO Use READ_WBS permission when BE is ready */}
      <SidebarMenuItem
        linkUrl={getWBSDashboardUrl()}
        name="WBS Dashboard"
        icon="tasks"
        isVisible={isGranted(READ_PROJECT_DASHBOARD)}
      />
    </SidebarStickyMenu>
  );
};

export default ViewProjectPageMenu;
